<template>
  <div id="budgetCustomization">
    <div class="search-list">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="项目">
          <el-select v-model="formInline.region" placeholder="选择项目" size="mini">
            <el-option label="自动化项目" value="shanghai"></el-option>
            <el-option label="数据可视化项目" value="beijing"></el-option>
            <el-option label="看板项目" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
          <el-button type="info" @click="onSubmit" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableLists"
        row-key="id"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="项目名称"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="users"
          label="参与人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="syb"
          label="隶属事业部"
        >
        </el-table-column>
        <el-table-column
          prop="bm"
          label="隶属部门"
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="所得积分"
        >
        </el-table-column>
        <el-table-column
          prop="edit"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
            >
              分配
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch, getCurrentInstance, nextTick } from '@vue/composition-api'
export default {
  name: 'BudgetCustomization',
  props: [

  ],
  setup (props, ctx) {
    let tableLists = [{
      id: 1,
      date: '自动化',
      users: '18',
      address: '上海市普陀区金沙江路 1518 弄',
      syb: '大内容事业部',
      bm: '技术研发部',
      count: 2000
    },
    {
      id: 2,
      date: '数据可视化',
      users: '8',
      address: '上海市普陀区金沙江路 1518 弄',
      syb: '数字营销事业部',
      bm: '产品部',
      count: 200
    }, {
      id: 3,
      date: '看板',
      users: '2',
      address: '上海市普陀区金沙江路 1518 弄',
      syb: '财务部',
      bm: 'IT部',
      count: 1000
    }]
    let formInline = reactive({
      region: ''
    })
    let onSubmit = function () {}
    return {
      tableLists,
      formInline,
      onSubmit
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">

.word-nowrap-text
  white-space nowrap
  overflow: hidden
  text-overflow: ellipsis
</style>
